import { useEffect, useState } from "react";
import "./styles.css";

import icon from "../../assets/iconwhats.png";

const CtaWpp = (props) => {
  const [text, setText] = useState("SOLICITE UM ORÇAMENTO");

  useEffect(() => {
    if (props.text !== undefined) setText(props.text);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <button id="ctaWpp">
      <a
        href="http://wa.me/+5511986095730?text=Gostaria%20de%20solicitar%20um%20orçamento"
        target="_blank"
        rel="noreferrer"
      >
        <figure>
          <img src={icon} alt="Ícone do Whatsapp" />
        </figure>
        <p>{text}</p>
      </a>
    </button>
  );
};

export default CtaWpp;
